<div id="social-list">

  <ng-container *ngIf="isInitialized">
    <ul *ngIf="items && items.length > 0"
        class="widget__list"
        style="margin-bottom: 15px;">
      <li *ngFor="let item of items | paginate: { id: 'social', itemsPerPage: pagination.pageSize, currentPage:
          p, totalItems: pagination.total }"
          class="widget__list__carousel-item widget__list__carousel-item--tile">
        <div class="widget__list__carousel-img">
          <div class="widget__list__carousel-name">
            <fa-icon [icon]="['fab', item.icon]"></fa-icon>
          </div>
          <span class="widget__list__carousel-actions">
            <a [routerLink]="['social/edit', item.id]"
               class="widget__list__actions__link widget__list__actions__link--edit">
              <i class="ico-edit"></i>
            </a>
            <a [routerLink]="{ outlets: { 'modal': ['delete', item.id] } }"
               [queryParams]="{header:'Opravdu chcete smazat sociální síť ' + item.icon + '?', body: 'Odkaz již nebude možné obnovit.'}"
               class="widget__list__actions__link widget__list__actions__link--remove">
              <i class="ico-remove"></i>
            </a>
          </span>
        </div>
      </li>
    </ul>
  </ng-container>
  <pagination-controls *ngIf="pagination.pageSize > 0"
                       id="social"
                       (pageChange)="pageChanged($event)"
                       maxSize="9"
                       directionLinks="true"
                       autoHide="true"
                       previousLabel=""
                       nextLabel=""
                       screenReaderPaginationLabel="Pagination"
                       screenReaderPageLabel="Stránka"
                       screenReaderCurrentLabel="Jste na stránce">
  </pagination-controls>

  <div *ngIf="!isInitialized"
       class="widget__content loading"></div>

  <swb-no-data *ngIf="items && items.length === 0 && isInitialized"></swb-no-data>

</div>